(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';
  var BODY_LOCK_CLASS = 'is-drawer-open';

  function init() {
    var drawer = document.querySelector('[data-drawer]');
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close], [data-drawer-overlay]');
    if (!drawer || openers.length === 0) return;

    var lastFocused = null;

    function getFocusables() {
      return drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])',
      );
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.classList.add(OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add(BODY_LOCK_CLASS);
      openers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      var first = getFocusables()[0];
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove(OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(BODY_LOCK_CLASS);
      openers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (!drawer.classList.contains(OPEN_CLASS)) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        var focusables = getFocusables();
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    drawer.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', close);
    });
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
